// extracted by mini-css-extract-plugin
export default {"last-week":"NoAccess--last-week--UR4G9","lastWeek":"NoAccess--last-week--UR4G9","description":"NoAccess--description--YhEFs","graphic":"NoAccess--graphic--Rgc-J"};